import {createContext} from 'react';

const BudgetContext = createContext(null);

export default BudgetContext;
